import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import BuyButton from '../BuyButton';

const QuantityBuyButton = ({ selectedVariantArtNumber }) => {
  const [inputQuantity, setInputQuantity] = useState(1);
  const [hasProductSelected, setHasProductSelected] = useState(false);
  useEffect(() => {
    setHasProductSelected(!!selectedVariantArtNumber);
  }, [selectedVariantArtNumber]);

  const label = selectedVariantArtNumber
    ? translate('product-page.buy-button')
    : translate('product-page.select-variant');
  return (
    <div className="quantity-buy-button">
      <div
        className={`quantity-buy-button__quantity ${
          !hasProductSelected ? 'quantity-buy-button__quantity--disabled' : ''
        }`}
      >
        <div
          className="quantity-buy-button__icon"
          onClick={() =>
            hasProductSelected &&
            inputQuantity >= 2 &&
            setInputQuantity(inputQuantity - 1)
          }
        >
          <i className="ph-minus color-grey-500"></i>
        </div>
        <input
          className="text-large color-grey-900"
          type="number"
          value={inputQuantity}
          onChange={(e) => setInputQuantity(e.target.value)}
          min="1"
          max="9999"
          disabled={!hasProductSelected}
        />
        <div
          className="quantity-buy-button__icon"
          onClick={() =>
            hasProductSelected && setInputQuantity(inputQuantity + 1)
          }
        >
          <i className="ph-plus color-grey-500"></i>
        </div>
      </div>
      <BuyButton
        articleNumber={selectedVariantArtNumber}
        quantity={inputQuantity}
        label={label}
      />
    </div>
  );
};

export default QuantityBuyButton;
